import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import Keycloak from 'keycloak-js';

const axingAdminGroupName = 'axing_admin';

@Injectable()
export class KeycloakService {

  private keycloakAuth: Keycloak;

  init(): Promise<any> {
    return new Promise((resolve, reject) => {
      const config = {
        'url': environment.keycloakAuthURL,
        'realm': environment.keycloakRealm,
        'clientId': environment.keycloakClientID
      };
      this.keycloakAuth = new Keycloak(config);

      // Add token refresh handling
      this.keycloakAuth.onTokenExpired = () => {
        this.updateToken();
      };

      this.keycloakAuth.init({
        onLoad: 'login-required',
        silentCheckSsoRedirectUri: environment.keycloakRedirectURI + '/assets/silent-check-sso.html',
        checkLoginIframe: false,
        flow: 'standard',
        responseMode: 'query',
        redirectUri: window.location.href,
        useNonce: false
      })
        .then((authenticated: boolean) => {
          if (authenticated) {
            // Set up token refresh
            this.updateToken();
          }
          resolve(authenticated);
        })
        .catch((error: any) => {
          console.error('Keycloak init error:', error);
          if (error.error) {
            console.error('Error details:', error.error);
          }
          if (error.error_description) {
            console.error('Error description:', error.error_description);
          }
          reject(error);
        });
    });
  }

  updateToken(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.keycloakAuth.updateToken(70)
        .then((refreshed: boolean) => {
          resolve(refreshed);
        })
        .catch((error: any) => {
          this.keycloakAuth.login({
            redirectUri: window.location.href
          });
          reject(error);
        });
    });
  }

  getToken(): string {
    return this.keycloakAuth.token;
  }

  isAdmin(): boolean {
    const user = this.getUser();
    if (user.groups) {
      return user.groups.includes(axingAdminGroupName);
    }
    return false;
  }

  getUser(): any {
    return this.keycloakAuth.idTokenParsed;
  }

  getRoles(): any {
    return this.keycloakAuth.tokenParsed;
  }

  logout() {
    this.keycloakAuth.logout({
      redirectUri: environment.keycloakRedirectURI
    });
  }
}
